import { Checkbox, CheckboxGroup, CheckboxGroupProps } from '@heroui/react'
import { Field, FieldProps } from 'formik'
import { motion } from 'framer-motion'

interface Option {
  key: string
  label: string
}

export interface CheckboxGroupFormikProps
  extends Omit<CheckboxGroupProps, 'value' | 'onValueChange' | 'name'> {
  label: string
  classNameContainer?: string
  options: Option[]
  name: string
}

const CheckboxGroupFormik = ({
  label,
  classNameContainer,
  options,
  name,
  ...props
}: CheckboxGroupFormikProps) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <motion.div className={classNameContainer}>
          <CheckboxGroup
            label={label}
            value={field.value || []}
            onValueChange={(value: string[]) => form.setFieldValue(name, value)}
            {...props}
            classNames={{
              wrapper: 'flex flex-row gap-8',
              label: 'text-xs text-[#2A3580]',
              ...props.classNames,
            }}
          >
            {options.map((option: Option) => (
              <Checkbox
                key={option.key}
                value={option.key}
                classNames={{
                  label: 'text-[#2A3580]',
                  base: 'flex gap-1 items-center',
                }}
              >
                {option.label}
              </Checkbox>
            ))}
          </CheckboxGroup>
        </motion.div>
      )}
    </Field>
  )
}

export default CheckboxGroupFormik
